import makeStyles from '@mui/styles/makeStyles';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Grid from '@mui/material/Grid';
import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';
import { OrganizationFeature } from '../../../models';
import DialogTransition from '../../../components/transition/DialogTransition';
import { SubscriptionWarningIcon } from '../../../layout/CustomIcon';

const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: theme.spacing(2),
  },
  title: {
    color: theme.palette.warning.main,
    padding: theme.spacing(0, 3),
    fontWeight: theme.typography.fontWeightBold,
  },
  dialogContainer: {
    margin: theme.spacing(3),
    maxWidth: theme.spacing(63),
  },
  currentPlan: {
    fontWeight: theme.typography.fontWeightBold,
  },
  dialogContent: {
    lineHeight: theme.spacing(3),
    margin: theme.spacing(0.5, 0),
    color: '#172B4D',
    fontSize: '0.875rem',
  },
  contentItalic: {
    lineHeight: theme.spacing(3),
    margin: 0,
    color: '#172B4D',
    fontSize: '0.875rem',
    fontStyle: 'italic',
  },
  dialogContentContainer: {
    padding: theme.spacing(1, 3, 2, 3),
  },
  getBackButton: {
    color: '#233145',
    backgroundColor: '#F0F1F2',
    height: theme.spacing(4),
    fontWeight: theme.typography.fontWeightMedium,
  },
}));
interface SubscriptionWarningDialogProps {
  open: boolean;
  handleClose: () => void;
  currentTestCloudFeature: string;
}

const SubscriptionWarningDialog = (props: SubscriptionWarningDialogProps) => {
  const {
    open,
    handleClose,
    currentTestCloudFeature,
  } = props;
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{
        paper: classes.root,
      }}
      TransitionComponent={DialogTransition}
    >
      <div
        className={classes.dialogContainer}
      >
        <Grid
          container
          justifyContent="center"
        >
          <SubscriptionWarningIcon />
        </Grid>
        <Typography
          className={classes.title}
          variant="h3"
        >
          <FormattedMessage
            id="subscriptions.testcloud.warning_dialog.title"
          />
        </Typography>
        <DialogContent
          className={classes.dialogContentContainer}
        >
          <DialogContentText id="alert-dialog-description">
            <Typography
              className={classes.dialogContent}
            >
              <FormattedMessage
                id="subscriptions.testcloud.warning_dialog.current_plan"
                values={{
                  currentPlan: OrganizationFeature.getFeatureFullName(currentTestCloudFeature),
                  b: (chunk: string) => (<b>{chunk}</b>),
                }}
              />
            </Typography>
            <Typography
              className={classes.dialogContent}
            >
              <FormattedMessage
                id="subscriptions.testcloud.warning_dialog.cannot_use_different"
              />
            </Typography>
            <Typography
              className={classes.dialogContent}
            >
              <FormattedMessage
                id="subscriptions.testcloud.warning_dialog.cancel_first"
              />
            </Typography>
            <Typography
              fontWeight="bold"
              fontStyle="italic"
              className={classes.dialogContent}
            >
              <FormattedMessage
                id="subscriptions.testcloud.warning_dialog.notes"
              />
            </Typography>
            <Typography
              className={classes.contentItalic}
            >
              <FormattedMessage
                id="subscriptions.testcloud.warning_dialog.after_cancel"
              />
            </Typography>
            <Typography
              className={classes.contentItalic}
            >
              <FormattedMessage
                id="subscriptions.testcloud.warning_dialog.cancelling_mean"
              />
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="contained"
            className={classes.getBackButton}
          >
            <FormattedMessage id="subscriptions.testcloud.get_back_button" />
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default SubscriptionWarningDialog;
